import { generatePath, Params } from 'react-router-dom';
import { User } from 'us-web-services';

export const Routes = {
  app: '/app',
  backgroundCheck: '/buy-background-check',
  bookings: {
    id: '/bookings/:id',
    detail: '/bookings/:id/:detail',
    root: '/bookings',
  },
  caregiver: {
    dashboard: '/caregiver/dashboard',
  },
  creditCard: '/credit-card',
  credits: '/user/:id/credits',
  reimbursements: '/user/:id/reimbursements',
  feedback: '/family/feedback',
  homepage: '/',
  job: {
    applicant: '/job/:id/applicant/:userId',
    id: '/job/:id',
    edit: '/job/:id/edit',
    interest: '/job/:id/interest',
  },
  login: '/login',
  parent: {
    affiliations: '/sitters/affiliations/:alias',
    benefits: {
      activate: '/activate-benefits',
      confirm: '/confirm-benefits',
    },
    bookings: {
      addDetails: '/parent/bookings/add-details',
      agencyDate: '/parent/bookings/agency/date',
      confirmMultipleDates: '/parent/bookings/confirm-multiple-dates',
      date: '/parent/bookings/select-date',
      dates: '/parent/bookings/select',
      frequency: '/parent/bookings/frequency',
    },
    bookedSitters: '/parent/:id/booked-sitters',
    bookSitter: '/parent/bookings/select',
    company: '/sitters/companies/:alias',
    dashboard: '/family/dashboard',
    informationalScreen: '/family/agency-information',
    explore: '/parent/:id/explore-lists',
    feedback: '/parent/:id/feedback',
    friends: '/sitters/friends',
    jobPost: '/job-post',
    localGroups: '/sitters/local-groups/:alias',
    messages: '/parent/:id/messages',
    messageSitter: '/parent/:id/messages/:sitterId',
    notifications: '/parent/:id/notifications',
    packages: '/parent/packages',
    posts: '/posts',
    profile: '/parent/:id',
    registration: {
      assistant: '/family-reg/assistant',
      gettingStarted: '/family-reg/getting-started',
      vertical: '/family-reg/vertical',
      frequency: '/family-reg/frequency',
      petType: '/family-reg/pet-type',
      great: '/family-reg/great',
      includes: '/family-reg/includes',
      sweeteners: '/family-reg/sweeteners',
      fantastic: '/family-reg/fantastic',
      success: '/family-reg/success',
      location: '/family-reg/location',
      details: '/family-reg/details',
      photo: '/family-reg/photo',
      profilePreview: '/family-reg/profile-preview',
      selectDateTimes: '/family-reg/select-date-times',
      count: '/family-reg/count',
      confirm: '/family-reg/confirm',
      trustSafety: '/parent-registration/trust-safety',
    },
    savedSearches: '/parent/:id/saved-searches',
    schools: '/sitters/schools/:alias',
    settings: '/parent/:id/settings',
    sitters: '/sitters',
    sitterCalendar: '/sitter/:sitterId/calendar',
    yourSitters: '/parent/:id/your-sitters',
  },
  public: {
    aboutUs: '/about-us',
    careers: '/careers/',
    giftCards: '/gift-cards',
    privacyPolicy: '/privacy-policy',
    terms: '/terms-of-service/',
    trust: '/trust/',
  },
  referral: '/referral',
  savedSearches: '/saved-searches',
  sitter: {
    backgroundCheck: '/buy-background-check',
    calendar: '/sitter-calendar',
    jobBoard: '/job-board',
    messages: '/sitter/:id/messages',
    notifications: '/sitter/:id/notifications',
    payout: '/sitter/payout',
    profile: '/sitter/:id',
    registration: {
      availability: '/sitter/registration/availability',
      worksWith: '/sitter/registration/works-with',
    },
    settings: '/sitter/:id/settings',
    successGuide: '/sitter/success-guide',
    yourFamilies: '/sitter/:id/your-families',
  },
  support: 'https://support.urbansitter.com/',
  user: {
    creditCard: '/user/:id/credit-card',
  },
  transactions: '/transactions',
};

export class RoutesHelper {
  static getDashboard(user?: User): string {
    return user?.parent ? Routes.parent.dashboard : Routes.caregiver.dashboard;
  }
}

export const getUrlFromPath = (route: string, params?: Params<string> | undefined): string => `/app${generatePath(route, params)}`;
